import type { Dict } from '@/types'

export const mapObject = (object: Dict, callback: (key: string, value: any) => [string, any]) =>
  Object.fromEntries(Object.entries(object).map(([key, value]) => callback(key, value)))
